/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpSharedShippingHolidayDelivery_item = {
    readonly isAuctionEnabled: boolean | null;
    readonly holidayShippingEstimations?: {
        readonly displayMessage: string | null;
        readonly termsAndConditions: string | null;
        readonly validHolidayShippingDays: ReadonlyArray<{
            readonly shipmentQuoteId: string | null;
            readonly estimatedDeliveryDay: string | null;
        } | null> | null;
    } | null | undefined;
    readonly " $refType": "PdpSharedShippingHolidayDelivery_item";
};
export type PdpSharedShippingHolidayDelivery_item$data = PdpSharedShippingHolidayDelivery_item;
export type PdpSharedShippingHolidayDelivery_item$key = {
    readonly " $data"?: PdpSharedShippingHolidayDelivery_item$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedShippingHolidayDelivery_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isClient"
    },
    {
      "kind": "RootArgument",
      "name": "timezoneOffset"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedShippingHolidayDelivery_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAuctionEnabled",
      "storageKey": null
    },
    {
      "condition": "isClient",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "timezoneOffset",
              "variableName": "timezoneOffset"
            }
          ],
          "concreteType": "HolidayShippingEstimationsType",
          "kind": "LinkedField",
          "name": "holidayShippingEstimations",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayMessage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "termsAndConditions",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ValidHolidayShippingDays",
              "kind": "LinkedField",
              "name": "validHolidayShippingDays",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "shipmentQuoteId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "estimatedDeliveryDay",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = 'a5b4f39d2d46f35822f6d3c116e12eb5';
export default node;
